import { graphql } from '@generated/gql';

export const APP_BAR_AVATAR_ME = graphql(/** GraphQL */ `
  query appBarAvatarMe {
    me {
      avatar
      firstName
      lastName
    }
  }
`);
